module.exports = __webpack_public_path__ + "img/mail.d0731af1.svg";